<!--
  Controllo Qualità — placeholder "Pagina in costruzione" (v2.12.1 R.3).
  Phase 1.5 closure: restyle reale rimandato a Phase 2. La page-style
  header Diakonix è preservato come per le altre page list; il body
  contiene solo l'illustration di placeholder + messaggio per spiegare
  all'utente perché l'area è in attesa.
-->
<div class="cq-page">
  <!-- Sticky header coerente con altre pagine Diakonix -->
  <header class="cq-header">
    <div class="cq-header__titles">
      <h1 class="cq-header__title">🛡️ Controllo qualità</h1>
      <p class="cq-header__subtitle">
        Workflow di verifica post-preparazione ordine
      </p>
    </div>
  </header>

  <!-- Placeholder content -->
  <section class="cq-construction" aria-label="Pagina in costruzione">
    <div class="cq-construction__art" aria-hidden="true">
      <div class="cq-construction__icon">🚧</div>
      <div class="cq-construction__pulse"></div>
    </div>

    <h2 class="cq-construction__title">Pagina in costruzione</h2>
    <p class="cq-construction__msg">
      Stiamo lavorando per migliorare quest'area.<br />
      Il nuovo flusso di controllo qualità arriverà con la prossima fase
      di sviluppo Diakonix.
    </p>

    <div class="cq-construction__chips">
      <span class="cq-chip">✓ Resto della piattaforma operativa</span>
      <span class="cq-chip">⏳ Restyle in arrivo</span>
    </div>
  </section>
</div>
